// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G5Es","field":"styles_field__2IEGz","fieldCol":"styles_fieldCol__2PJl4","diffCol":"styles_diffCol__2Iu6l","diff":"styles_diff__b8lr3"};